export function getName(player, data) {
	return data.episode != null // data.episode не null и не undefined
		? `${player.localize('Episode')}-${data.episode}`
		: data.name;
}
